var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#F4F6FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1667 12.9167H11.175L12.2583 11.8417C12.4153 11.6848 12.5034 11.4719 12.5034 11.25C12.5034 11.0281 12.4153 10.8153 12.2583 10.6583C12.1014 10.5014 11.8886 10.4133 11.6667 10.4133C11.4448 10.4133 11.2319 10.5014 11.075 10.6583L8.57501 13.1583C8.49914 13.2376 8.43967 13.3311 8.40001 13.4333C8.31666 13.6362 8.31666 13.8638 8.40001 14.0667C8.43967 14.169 8.49914 14.2624 8.57501 14.3417L11.075 16.8417C11.1525 16.9198 11.2446 16.9818 11.3462 17.0241C11.4477 17.0664 11.5567 17.0882 11.6667 17.0882C11.7767 17.0882 11.8856 17.0664 11.9872 17.0241C12.0887 16.9818 12.1809 16.9198 12.2583 16.8417C12.3364 16.7642 12.3984 16.672 12.4407 16.5705C12.4831 16.4689 12.5048 16.36 12.5048 16.25C12.5048 16.14 12.4831 16.0311 12.4407 15.9295C12.3984 15.828 12.3364 15.7358 12.2583 15.6583L11.175 14.5833H19.1667C19.3877 14.5833 19.5996 14.6711 19.7559 14.8274C19.9122 14.9837 20 15.1957 20 15.4167V18.75C20 18.971 20.0878 19.183 20.2441 19.3393C20.4004 19.4955 20.6123 19.5833 20.8333 19.5833C21.0544 19.5833 21.2663 19.4955 21.4226 19.3393C21.5789 19.183 21.6667 18.971 21.6667 18.75V15.4167C21.6667 14.7536 21.4033 14.1178 20.9344 13.6489C20.4656 13.1801 19.8297 12.9167 19.1667 12.9167V12.9167Z",
    fill: "#2C3782"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackCircle);
export default __webpack_public_path__ + "static/media/back_circle.61e28eba.svg";
export { ForwardRef as ReactComponent };